import MapUtil from 'gw-portals-util-js/MapUtil';

var protocol = document.location.protocol === 'https:' ? 'https' : 'http';
var googleMapsApiSrc = protocol + '://maps.googleapis.com/maps/api/js?key=' + MapUtil.getApiKey() + '&libraries=geometry,places';

function googleMapsLoader() {
    var isLoadingGoogleMaps = false;
    return function () {
        if (!isLoadingGoogleMaps) {
            isLoadingGoogleMaps = true;
            var script = document.createElement('script');
            script.async = true;
            document.head.appendChild(script);
            script.src = googleMapsApiSrc;
            script.onerror = function () {
                isLoadingGoogleMaps = false;
            };
        }
    };
}

export default googleMapsLoader();


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-google-maps-js/module.js
// module id = 316
// module chunks = 0